import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

interface IRoleProtectedRoutes {
  isAllowed: boolean;
  redirectPath?: string;
  children?: React.ReactElement;
}
const RoleProtectedRoutes: React.FC<IRoleProtectedRoutes> = ({
  isAllowed,
  redirectPath = "/",
  children,
}) => {
  const location = useLocation();

  if (!isAllowed) {
    // console.log("NOT ALLOWED===>", isAllowed);

    return <Navigate to={redirectPath} replace state={{ from: location }} />;
  }

  return children ? children : <Outlet />;
};

export default RoleProtectedRoutes;
